// extracted by mini-css-extract-plugin
export var sbShowMain = "languageSwitch-module--sb-show-main--1ClHx";
export var container = "languageSwitch-module--container--2H5bB";
export var active = "languageSwitch-module--active--3VJlN";
export var languageSwitch = "languageSwitch-module--languageSwitch--J8jq_";
export var lang = "languageSwitch-module--lang--34Q5R";
export var dropdown = "languageSwitch-module--dropdown--1vxQD";